import { render, staticRenderFns } from "./AddIconHomeScreen.vue?vue&type=template&id=6d1a16c6"
import script from "./AddIconHomeScreen.vue?vue&type=script&lang=js"
export * from "./AddIconHomeScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports